var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"oauth"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"variant":"white","opacity":"0.7"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }